import { ContractType, SkyportalFeatureName, UserAccessType } from ".";

export const FROM_URL_PARAM = "fromUrl";
export const LOGOUT_PATH = "/cite/logout";

export const CONTRACT_TYPES = {
  BU: "BU" as ContractType,
  BA: "BA" as ContractType,
  DR: "DR" as ContractType,
  IA: "IA" as ContractType,
  ST: "ST" as ContractType,
  NS: "NS" as ContractType,
  MW: "MW" as ContractType,
  SS: "SS" as ContractType,
  SE: "SE" as ContractType,
  SD: "SD" as ContractType,
  ES: "ES" as ContractType,
  PC: "PC" as ContractType,
};

export const FEATURES = {
  CLIENT_ASSIGNMENT: "client_assignment" as SkyportalFeatureName,
  JOBS_ASSIGNMENT: "jobs_assignment" as SkyportalFeatureName,
  PRICING_CONFIG: "pricing_config" as SkyportalFeatureName,
  STORAGE_ASSIGNMENT: "storage_assignment" as SkyportalFeatureName,
  IAAS_VIRTUAL_MACHINES: "iaas.virtual_machines" as SkyportalFeatureName,
  IAAS_DISKS: "iaas.disks" as SkyportalFeatureName,
  IAAS_VNC_CONSOLE: "iaas.vnc_console" as SkyportalFeatureName,
  IAAS_USAGE_REPORT: "iaas.usage_report" as SkyportalFeatureName,
  IAAS_USAGE_REPORT_DETAILED: "iaas.usage_report_detailed" as SkyportalFeatureName,
  OTHER_DOCUMENTATION: "other.documentation" as SkyportalFeatureName,
  OTHER_CUSTOMER_STATUS_LIST: "other.customer_status_list" as SkyportalFeatureName,
};

export const USER_ACCESS = {
  VIEW: "view" as UserAccessType,
  CREATE: "create" as UserAccessType,
  UPDATE: "update" as UserAccessType,
  DELETE: "delete" as UserAccessType,
};
